import { Card as MantineCard } from '@mantine/core';
import { ReactElement, ReactNode } from 'react';

import ConditionalTooltip from '@/components/ConditionalTooltip.tsx';
import InstanceIndicator from '@/components/InstanceIndicator.tsx';
import PriorityMarker from '@/components/PriorityMarker.tsx';

import { Priority } from '@/models/appointment/Appointment.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props<T> {
    data: T;
    instanceId: string;
    disabled: boolean;
    onClick: (item: T) => void;
    priority?: Priority;
    children: ReactNode;
    tooltipText?: string;
    compact?: boolean;
}

const Card = <T,>({
    data,
    instanceId,
    disabled,
    onClick,
    priority,
    children,
    tooltipText,
    compact = false,
}: Props<T>): ReactElement => {
    return (
        <ConditionalTooltip label={tooltipText}>
            <MantineCard
                className={cn(
                    'relative select-none rounded-lg border border-neutral-200 shadow-md transition duration-100 hover:bg-slate-50 dark:bg-neutral-800 dark:hover:bg-neutral-700',
                    compact ? 'gap-1 p-4' : 'gap-2 xl:p-6',
                    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                )}
                onClick={() => {
                    if (!disabled) onClick(data);
                }}
            >
                <InstanceIndicator instanceId={instanceId} />
                {priority && <PriorityMarker priority={priority} />}
                {children}
            </MantineCard>
        </ConditionalTooltip>
    );
};

export default Card;
